import { createModuleStore } from '../utils'

export const useItemsHierarchyStore = createModuleStore(
  'items-hierarchy',
  {
    type: 'Item with RFID Tag(s)',
    pageHeading: 'Consist Report',
    noHistory: true,
    noActivate: true,
    noCopy: true,
    noStatus: true,
    noSettings: true,
    noDeactivate: true,
    noDelete: true,
    noTimeline: true,
    noEdit: true,
    noSort: true,
    noAdd: true,
    noColumnSelection: true,
    noProviderSorting: true,
    noProviderFiltering: true,
    noProviderPaging: true,
    uploadOptionsCsv: '',
    uri: '/reports/consists-report',
    serviceUri: '/reports/consists',
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    listingModuleName: 'Reports',
    listingActivityName: 'View Consists Report',
    formModuleName: 'Reports',
    formActivityName: 'Edit Consists Report',
    allFields: [],
  },
  {},
  {
    makeHierarchy(items, renderColumnFn) {
      const multiSort = (arr, keys) => {
        const splitKeyChar = '~'
        const generateSortString = (obj) => {
          return keys.map((key) => obj[key]?.serialNumber || obj[key]?.vehicleNo).join(splitKeyChar)
        }
        return arr.sort((a, b) => {
          const sortStr1 = generateSortString(a)
          const sortStr2 = generateSortString(b)
          const result = sortStr1.localeCompare(sortStr2)
          return result
        })
      }
      const enhancedData = items.map((d) => {
        if (!d.parent) {
          return { ...d, parent: null }
        } else {
          return d
        }
      })
      const cache = {}
      const parents = {}
      let maxDepth = 0
      const depth = (con) => (con.parent === null ? 0 : 1 + depth(con.parent))
      enhancedData?.forEach((con) => (cache[con.externalId] = con))
      enhancedData?.forEach((con) => {
        const parent = con.parent
        if (parent && cache[parent]) {
          con.parent = cache[parent]
          parents[parent] = cache[parent]
        }
      })
      enhancedData?.forEach((con) => {
        const d = depth(con)
        con.depth = d
        if (d > maxDepth) maxDepth = d
      })
      const flatItems = []
      const columns = ['parent']
      for (let ix = 1; ix <= maxDepth; ix++) columns.push(`child${ix}`)
      enhancedData
        ?.filter((d) => parents[d.externalId] == null && d.parent)
        .forEach((item) => {
          const row = {}
          let node = item
          for (let ix = maxDepth; ix >= 0; ix--) {
            const d = item.depth
            if (ix > d) {
              row[`child${ix}`] = null
            } else {
              row[ix === 0 ? 'parent' : `child${ix}`] = node
              node = node?.parent
            }
          }
          flatItems.push(row)
        })
      const store = useItemsHierarchyStore()
      store.allFields = columns.map((d) => ({
        key: d,
        title: d.toUpperCase(),
        className: 'consist-cell-content',
        render: (row) => renderColumnFn(row[d]),
      }))
      store.totalRows = flatItems.length
      return multiSort(flatItems, columns)
    },
  },
  {}
)
